import React, { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Row } from "antd";

import Language from "./language";
import csCZ from "antd/es/locale/cs_CZ";
import plPL from "antd/es/locale/pl_PL";
import enGB from "antd/es/locale/en_GB";
import { useAuth } from "../../../modules/redux/session/useAuth";
import { setSession } from "../../../modules/redux/session/action";
import { setLanguage } from "../../../modules/redux/language/actions";
import { patchEntity, getEntities } from "../../../modules/crudOperations";

import "./index.css";

export const czechLocale = "cs-CZ";
export const czech = "cs";
export const polish = "pl";
export const english = "en";
export const languageKey = "language";

const Languages = ({ onLanguageSetting }) => {
  const dispatch = useDispatch();
  const [languages, setLanguages] = useState();
  useEffect(() => getEntities("language", setLanguages), []);

  const session = useAuth();
  const user = session?.user;
  const [activeLanguage, setActiveLanguage] = useState(czech);
  const handleLanguageSet = useCallback(
    (language, languageChange = true) => {
      language = languageChange
        ? language
        : (user && user.language) ||
          language ||
          (languages.find &&
            navigator.language &&
            languages.find(
              (l) => l.iso6391Code === navigator.language.split("-")[0],
            ));
      if (language) {
        dispatch(setLanguage(language));
        setActiveLanguage(language.iso6391Code);
        let locale;
        switch (language.iso6391Code) {
          case english:
            locale = enGB;
            break;
          case polish:
            locale = plPL;
            break;
          default:
            locale = csCZ;
            break;
        }
        onLanguageSetting({ locale: language.localization, antLocale: locale });
        if (languageChange) {
          localStorage.setItem(languageKey, JSON.stringify(language));
          user &&
            dispatch(
              setSession({
                ...session,
                user: { ...user, language: { ...language } },
              }),
            );
          user && patchEntity("user", user.id, { language: language.id });
        }
      }
    },
    [user, session, dispatch, languages, onLanguageSetting],
  );

  useEffect(() => {
    if (languages) {
      const language = localStorage.getItem(languageKey);
      handleLanguageSet(language && JSON.parse(language), false);
    }
  }, [languages, handleLanguageSet]);

  return (
    <Row type="flex" gutter={30} align="middle" justify="space-around">
      {languages && languages !== "e" ? (
        languages.map((l, i) => (
          <Language
            key={i}
            language={l}
            title={l.name}
            span={24 / languages.length}
            languageName={l.iso6391Code}
            disabled={l.iso6391Code === "pl"}
            onLanguageClick={handleLanguageSet}
            active={activeLanguage === l.iso6391Code}
          />
        ))
      ) : (
        <Language
          active
          title="čeština"
          languageName={czech}
          onLanguageClick={handleLanguageSet}
        />
      )}
    </Row>
  );
};

export default Languages;
